(() => {
  'use strict';
  const $ = (id) => document.getElementById(id);
  const payload = $('a-frame-v2-data');
  if (!payload) return;
  const data = JSON.parse(payload.textContent);
  const media = data.media;

  const swaps = {
    home: {ids: ['at-home', 'at-home-alt'], labels: ['Another moment', 'First moment']},
    material: {ids: ['texture', 'texture-alt'], labels: ['Paws in action', 'First view']},
    structure: {ids: ['studio', 'studio-alt'], labels: ['Another angle', 'First angle']}
  };
  document.querySelectorAll('[data-swap]').forEach((button) => {
    const key = button.dataset.swap;
    const config = swaps[key];
    const toggle = $(`${key}-switch`);
    let latched = false;
    let hovering = false;
    const render = () => {
      const alternate = latched || hovering;
      button.classList.toggle('is-alternate', alternate);
      button.dataset.zoom = config.ids[Number(alternate)];
      const item = media.find((entry) => entry.id === button.dataset.zoom);
      $(`${key}-caption`).textContent = item.caption;
      button.setAttribute('aria-label', `Enlarge image: ${item.caption}`);
      toggle.setAttribute('aria-pressed', String(latched));
      toggle.textContent = config.labels[Number(latched)];
    };
    button.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') { hovering = true; render(); }
    });
    button.addEventListener('pointerleave', () => { hovering = false; render(); });
    toggle.addEventListener('click', () => { latched = !latched; render(); });
  });

  const dialog = $('image-dialog');
  const enlarged = $('dialog-image');
  const thumbs = $('dialog-thumbnails');
  let collection = media;
  let selected = 0;
  let returnFocus = null;
  let savedOverflow = '';
  const renderImage = () => {
    const item = collection[selected];
    enlarged.width = item.width;
    enlarged.height = item.height;
    enlarged.src = item.src;
    enlarged.alt = item.caption;
    $('dialog-caption').textContent = item.caption;
    $('dialog-counter').textContent = `${selected + 1} / ${collection.length}`;
    [...thumbs.children].forEach((button, index) => {
      button.setAttribute('aria-current', index === selected ? 'true' : 'false');
      button.classList.toggle('is-current', index === selected);
    });
    const active = thumbs.children[selected];
    if (active) {
      const target = active.offsetLeft - thumbs.clientWidth / 2 + active.clientWidth / 2;
      thumbs.scrollTo({left: target, behavior: 'instant'});
    }
  };
  const advance = (direction) => {
    selected = (selected + direction + collection.length) % collection.length;
    renderImage();
  };
  const openGallery = (items, index, trigger) => {
    collection = items;
    selected = Math.max(0, index);
    returnFocus = trigger;
    thumbs.replaceChildren();
    items.forEach((item, position) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'dialog-thumb';
      button.setAttribute('aria-label', `View image ${position + 1}: ${item.caption}`);
      const img = document.createElement('img');
      img.src = item.thumbnail || item.src;
      img.alt = '';
      img.loading = 'lazy';
      button.append(img);
      button.addEventListener('click', () => { selected = position; renderImage(); });
      thumbs.append(button);
    });
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    renderImage();
    $('dialog-close').focus();
  };
  document.querySelectorAll('[data-zoom]').forEach((button) => {
    button.addEventListener('click', () => {
      openGallery(media, media.findIndex((item) => item.id === button.dataset.zoom), button);
    });
  });
  $('dialog-close').addEventListener('click', () => dialog.close());
  $('dialog-previous').addEventListener('click', () => advance(-1));
  $('dialog-next').addEventListener('click', () => advance(1));
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      advance(event.key === 'ArrowLeft' ? -1 : 1);
    }
  });
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog || event.target.classList.contains('dialog-image-wrap')) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = savedOverflow;
    returnFocus?.focus({preventScroll: true});
  });
  let touch = null;
  enlarged.addEventListener('touchstart', (event) => {
    if (event.touches.length === 1) touch = {x: event.touches[0].clientX, y: event.touches[0].clientY};
  }, {passive: true});
  enlarged.addEventListener('touchend', (event) => {
    if (!touch || !event.changedTouches.length) return;
    const dx = event.changedTouches[0].clientX - touch.x;
    const dy = event.changedTouches[0].clientY - touch.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) advance(dx < 0 ? 1 : -1);
    touch = null;
  }, {passive: true});

  const productForm = $('AFrameProductForm');
  const variant = data.variant;
  const rule = variant.quantityRule || {};
  const minimum = Math.max(1, Number(rule.min) || 1);
  const increment = Math.max(1, Number(rule.increment) || 1);
  let maximum = rule.max == null ? Infinity : Math.max(minimum, Number(rule.max));
  if (variant.inventoryTracked && variant.inventoryPolicy === 'deny') maximum = Math.min(maximum, Math.max(0, Number(variant.inventoryQuantity)));
  let quantity = minimum;
  const syncQuantity = next => {
    quantity = minimum + Math.max(0, Math.round((Number(next) - minimum) / increment)) * increment;
    if (Number.isFinite(maximum) && maximum >= minimum) quantity = Math.min(quantity, minimum + Math.floor((maximum - minimum) / increment) * increment);
    $('quantity').textContent = String(quantity);
    productForm.querySelector('[name="quantity"]').value = String(quantity);
    $('quantity-minus').disabled = quantity <= minimum;
    $('quantity-plus').disabled = quantity + increment > maximum;
  };
  $('quantity-minus').addEventListener('click', () => syncQuantity(quantity - increment));
  $('quantity-plus').addEventListener('click', () => syncQuantity(quantity + increment));
  productForm.addEventListener('submit', event => {
    if (!variant.available || maximum < minimum) event.preventDefault();
    else syncQuantity(quantity);
  });
  syncQuantity(minimum);
  const mobileBar = $('mobile-options-bar');
  const options = $('options');
  let scheduled = false;
  const updateMobileBar = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      const visible = window.matchMedia('(max-width:750px)').matches && options.getBoundingClientRect().bottom <= 0;
      mobileBar.classList.toggle('is-visible', visible);
      mobileBar.setAttribute('aria-hidden', String(!visible));
      mobileBar.toggleAttribute('inert', !visible);
      mobileBar.inert = !visible;
      scheduled = false;
    });
  };
  for (const event of ['scroll', 'resize', 'pageshow']) window.addEventListener(event, updateMobileBar, { passive: true });
  updateMobileBar();
  const revealHash = () => {
    if (location.hash === '#delivery') $('delivery').open = true;
  };
  window.addEventListener('hashchange', revealHash);
  revealHash();

})();
